/**
 * Session Service
 * Business logic for session and message management
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateId } from "../core/utils/formatters";
/**
 * Session Service
 * Handles session creation and message management
 */
export class SessionService {
    constructor(sessionAPI, chatAPI) {
        this.sessionAPI = sessionAPI;
        this.chatAPI = chatAPI;
        this.sessionId = null;
        this.messages = [];
    }
    /**
     * Get current session ID (may be null initially)
     * The API will auto-generate and return a session_id on first message
     */
    getSessionId() {
        return this.sessionId;
    }
    /**
     * Set session ID (called when API returns session_id)
     */
    setSessionId(sessionId) {
        this.sessionId = sessionId;
    }
    /**
     * Send a message in the current session
     */
    sendMessage(content, onChunk, onComplete, onError) {
        return __awaiter(this, void 0, void 0, function* () {
            // Add user message to history
            const userMessage = this.createMessage("user", content);
            this.messages.push(userMessage);
            // Send via API (session_id is optional - API will create if needed)
            yield this.chatAPI.sendMessage(this.sessionId, content, onChunk, (returnedSessionId) => {
                // Update session ID if returned from API
                if (returnedSessionId && !this.sessionId) {
                    this.setSessionId(returnedSessionId);
                }
                onComplete();
            }, onError);
        });
    }
    /**
     * Add a message to history
     */
    addMessage(message) {
        this.messages.push(message);
    }
    /**
     * Update the last message content
     */
    updateLastMessage(content) {
        if (this.messages.length > 0) {
            this.messages[this.messages.length - 1].content = content;
        }
    }
    /**
     * Get all messages
     */
    getMessages() {
        return [...this.messages];
    }
    /**
     * Get chat state
     */
    getChatState() {
        return {
            isOpen: false,
            messages: this.getMessages(),
            sessionId: this.sessionId,
            isLoading: false,
        };
    }
    /**
     * Clear all messages
     */
    clearMessages() {
        this.messages = [];
    }
    /**
     * Create a message object
     */
    createMessage(role, content) {
        return {
            id: generateId(),
            role,
            content,
            timestamp: Date.now(),
        };
    }
}
